import Vue from 'vue'
import alpha from '@/tools/alpha'
import compareObj from '@/tools/equalObj'
import cloneDeep from '@/third/CloneDeep'
import varType from '@/tools/varType'
import _ from 'lodash'
import { getSurveyCode as getSurveyCodeService, getSurveySubCode as getSurveySubCodeService } from '@/service/question'
const IPT = '!important;'
const genList = (rows) => {
  rows.forEach((item, index) => {
    item.orderById = index
    delete item.value
    delete item.otherAnswer
    delete item.tmpValue
  })
  return rows
}

const assignField = (newItem, data, field) => {
  if (data !== undefined) {
    newItem[field] = data
  }
}

// 随机数组部分位置固定不随机
const shuffleWithFixed = (arr, fixedIndexes) => {
  // 复制原数组并删除固定位置的元素
  const tempArr = [...arr];
  for (let i = fixedIndexes.length - 1; i >= 0; i--) {
    tempArr.splice(fixedIndexes[i], 1);
  }
  
  // 随机
  for (let i = tempArr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [tempArr[i], tempArr[j]] = [tempArr[j], tempArr[i]];
  }

  // 将固定位置的元素插入到对应位置
  for (let i = 0; i < fixedIndexes.length; i++) {
    const index = fixedIndexes[i];
    tempArr.splice(index, 0, arr[index]);
  }
  
  return tempArr;
}

// 随机排序
const randomSort = (arr, qu, type) => {
  const { answerConfig: { fixedOptions, fixedChildren } } = qu
  let fixedIndexes = []

  if (type === 'option' && fixedOptions.length) {
    // 选项
    for (let i=0; i<arr.length; i++) {
      if (fixedOptions.includes(arr[i].id)) {
        fixedIndexes.push(i)
      }
    }
  } else if (type === 'desc' && fixedChildren.length) {
    // 子问题
    for (let i=0; i<arr.length; i++) {
      if (fixedChildren.includes(arr[i].id)) {
        fixedIndexes.push(i)
      }
    }
  } else if (type === 'group' && qu.questionGroupFixed && qu.questionGroupFixed.length) {
    // 题组
    for (let i=0; i<arr.length; i++) {
      if (qu.questionGroupFixed.includes(arr[i].id)) {
        fixedIndexes.push(i)
      }
    }
  }

  return shuffleWithFixed(arr, fixedIndexes)
}


// 循环数组部分位置固定不循环
const rotateWithFixed = (arr, fixedIndexes) => {
  // 复制原数组并删除固定位置的元素
  const tempArr = [...arr];
  for (let i = fixedIndexes.length - 1; i >= 0; i--) {
    tempArr.splice(fixedIndexes[i], 1);
  }

  // 循环
  const len = tempArr.length
  const shift = Math.floor(Math.random() * len) + 1
  for (let i = 0; i < shift; i++) {
    const temp = tempArr[len - 1]
    for (let j = len - 1; j >= 1; j--) {
      tempArr[j] = tempArr[j - 1]
    }
    tempArr[0] = temp
  }

  // 将固定位置的元素插入到对应位置
  for (let i = 0; i < fixedIndexes.length; i++) {
    const index = fixedIndexes[i];
    tempArr.splice(index, 0, arr[index]);
  }
  
  return tempArr;
}

// 循环排序
const rotateSort = (arr, qu, type) => {
  const { answerConfig: { fixedOptions, fixedChildren } } = qu
  let fixedIndexes = []

  if (type === 'option' && fixedOptions.length) {
    // 选项
    for (let i=0; i<arr.length; i++) {
      if (fixedOptions.includes(arr[i].id)) {
        fixedIndexes.push(i)
      }
    }
  } else if (type === 'desc' && fixedChildren.length) {
    // 子问题
    for (let i=0; i<arr.length; i++) {
      if (fixedChildren.includes(arr[i].id)) {
        fixedIndexes.push(i)
      }
    }
  } else if (type === 'group' && qu.questionGroupFixed && qu.questionGroupFixed.length) {
    // 题组
    for (let i=0; i<arr.length; i++) {
      if (qu.questionGroupFixed.includes(arr[i].id)) {
        fixedIndexes.push(i)
      }
    }
  }

  return rotateWithFixed(arr, fixedIndexes)
}

// 随机数组部分位置固定不随机
const sortWithFixedGroup = (arr, fixedIndexes, optRandType) => {
  // 复制原数组并删除固定位置的元素
  const tempArr = [...arr];

  for (let i = fixedIndexes.length - 1; i >= 0; i--) {
    tempArr.splice(fixedIndexes[i], 1);
  }
  
  // 根据组id进行分组
  const groupItemArr = _.groupBy(tempArr, 'optionGroupId')
  for(let key in groupItemArr) {
    if (optRandType === '02') {
      // 随机
      for (let i = groupItemArr[key].length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [groupItemArr[key][i], groupItemArr[key][j]] = [groupItemArr[key][j], groupItemArr[key][i]];
      }
    } else if (optRandType === '03') {
      // 循环
      const len = groupItemArr[key].length
      const shift = Math.floor(Math.random() * len) + 1
      for (let i = 0; i < shift; i++) {
        const temp = groupItemArr[key][len - 1]
        for (let j = len - 1; j >= 1; j--) {
          groupItemArr[key][j] = groupItemArr[key][j - 1]
        }
        groupItemArr[key][0] = temp
      }
    }
  }
  
  const tempNewArr = _.flatten(Object.values(groupItemArr))
  
  // 将固定位置的元素插入到对应位置
  for (let i = 0; i < fixedIndexes.length; i++) {
    const index = fixedIndexes[i];
    tempNewArr.splice(index, 0, arr[index]);
  }
  
  return tempNewArr;
}

// 随机排序（分组）
const handleSortGroup = (arr, qu) => {
  const { answerConfig: { fixedOptions, fixedChildren, optRandType, childRandType } } = qu
  let fixedIndexes = []

  if (['02', '03'].includes(childRandType)) {
    // 分组
    for (let i=0; i<qu.optionGroupList.length; i++) {
      if (fixedChildren.includes(qu.optionGroupList[i].id)) {
        fixedIndexes.push(i)
      }
    }
    if (childRandType === '02') {
      qu.optionGroupList = shuffleWithFixed(qu.optionGroupList, fixedIndexes)
    } else {
      qu.optionGroupList = rotateWithFixed(qu.optionGroupList, fixedIndexes)
    }
  }

  if (['02', '03'].includes(optRandType)) {
    // 选项
    fixedIndexes = []
    for (let i=0; i<arr.length; i++) {
      if (fixedOptions.includes(arr[i].id)) {
        fixedIndexes.push(i)
      }
    }
  }

  return sortWithFixedGroup(arr, fixedIndexes, optRandType)
}

/**
 * 生成选项/子问题列表（排序）
 * @param {*} rows
 * @param {*} type
 * @param {*} extraData
 * @returns
 */
const genRetList = function (rows, type, extraData) {
  const { queryType, answerConfig: { optRandType, childRandType } } = this
  let items = []
  rows.forEach((item, index) => {
    const newItem = {
      id: item.id,
      quId: item.quId,
      orderById: item.orderById,
      originTitle: item.optionName, // 记录原始标题
      optionName: item.optionName,
      visibility: '1'
    }

    // 处理选项名称转换
    // TODO 考虑统一所有选项名称逻辑，
    if (type === 'option' && (['NpsBox', 'RateBox', 'RateGroupBox', 'SatisfactionBox'].includes(this.elementType))) {
      newItem.originTitle = item.optionTitle
    } else {
      newItem.originTitle = item.optionName
    }

    // 满意度题
    if (type === 'option' && this.elementType === 'SatisfactionBox') {
      // init
      newItem.tags = item.tags
    }

    // 多项数字
    if (type === 'option' && this.elementType === 'MultiNumberBox') {
      // init
      newItem.answerConfig = JSON.parse(item.answerConfig)
      newItem.optionList = item.optionList  || []
    }

    const filterKeys = ['quoteQuId', 'answerType', 'type', 'imgUrl', 'imgName',
      'optionTitle', 'proportion', 'positionName', 'positionCode',
      'w', 'h', 'x', 'y', 'optionGroupId', 'optionBeforLogicsNew', 'quBeforLogicsNew']
    filterKeys.forEach(field => {
      assignField(newItem, item[field], field)
    })
    extraData && Object.assign(newItem, cloneDeep(extraData))
    items.push(newItem)
  })

  // TODO: 离线app由前端排序，window._env_ === 'android'
  if (window._env_ === 'android' && queryType === 'answer') {
    if (type === 'desc') {
      // 子问题
      if (childRandType === '02') {
        // 随机
        items = randomSort(items, this, type)
      } else if (childRandType === '03') {
        // 循环
        items = rotateSort(items, this, type)
      }
    } else if (type === 'option') {
      if (this.optionGroupList && this.optionGroupList.length) {
        // 分组
        items = handleSortGroup(items, this)
      } else {
        // 非分组
        if (optRandType === '02') {
          items = randomSort(items, this, type)
        } else if (optRandType === '03') {
          items = rotateSort(items, this, type)
        }
      }
    }
  }
  return items
}

/**
 * 替换引用占位符
 * @param {*} title
 * @param {*} replacement
 * @returns
 */
const quoteReplace = (title, replacement) => {
  const reg = new RegExp('\\${(\\w+)://([^/}]+/)+(\\w+)}', 'g')
  return title.replace(reg, (quotePhase) => {
    // quoteMap.push(quotePhase)
    return replacement
  })
}
/**
 * 替换引用占位符
 *
 * @param {*} str #{name} -> ${customerAttrs://name}
 * @param {*} custQuote [{ attributeType: 'clientProperty', filed: 'name', value: '小明'}]
 * @returns value
 */
const handlePlace = (str, custQuote, lang) => {
  // TODO lang 参数暂时没有用到，后续需要考虑引用数据的多语言问题
  // 是否为预览模式（预览模式返回key）
  let index = window.location.href.split('&').findIndex(item => item === 'view=preview')

  if (!custQuote) return false

  // 客户属性
  const clientPropertyReg = /\$\{(clientProperty):\/\/(\w+)}/g
  // 事件属性
  const eventReg = /\$\{(event):\/\/([\w\-]+)}/g
  // 客户自定义标签
  const customTagReg = /\$\{(customTag):\/\/(\w+)}/g
  // 客户标签
  const tagReg = /\$\{(tag):\/\/(\w+)}/g
  // 车辆标签
  const carTagReg = /\$\{(carTag):\/\/(\w+)}/g

  // 字符串替换
  str = str.replace(clientPropertyReg, function (matchKey) {
    return matchStr(matchKey, clientPropertyReg, custQuote) || (index !== -1 ? matchKey : '')
  })
  str = str.replace(eventReg, function (matchKey) {
    return matchStr(matchKey, eventReg, custQuote) || (index !== -1 ? matchKey : '')
  })
  str = str.replace(customTagReg, function (matchKey) {
    return matchStr(matchKey, customTagReg, custQuote) || (index !== -1 ? matchKey : '')
  })
  str = str.replace(tagReg, function (matchKey) {
    return matchStr(matchKey, tagReg, custQuote) || (index !== -1 ? matchKey : '')
  })
  str = str.replace(carTagReg, function (matchKey) {
    return matchStr(matchKey, carTagReg, custQuote) || (index !== -1 ? matchKey : '')
  })

  return str
}

function matchStr(matchKey, reg, custQuote) {
  // reg.exec(matchKey)
  new RegExp(reg).exec(matchKey)
  const property = RegExp.$1, key = RegExp.$2
  let quoteObj, quoteValue

  if (Array.isArray(custQuote[property])) {
    quoteObj = custQuote[property].find(item => item.field === key)
  }

  if (quoteObj && quoteObj.attributeType === 'event') {
    // 事件单独处理
    quoteValue = (quoteObj && !['[]', 'null', ''].includes(quoteObj.value)) ? JSON.parse(quoteObj.value).join(', ') : ''
  } else {
    quoteValue = quoteObj ? quoteObj.value : ''
  }

  return quoteValue
}

const calcQuNum = (questionList) => {
  let num = 1
  let code = 65
  questionList.forEach((item, index) => {
    const elementType = item.elementType
    if (elementType !== 'GroupBox' && elementType !== 'PageBox') {
      item.quNum = `Q${num++}`
    } else {
      item.quNum = String.fromCharCode(code++)
    }
  })
  return questionList
}

const calcGroupNum = groupList => {
  let code = 65
  groupList.forEach(item => {
    item.allOrderById = item.orderById * 1000
    if (item.groupType === '2') {
      item.quNum = String.fromCharCode(code++)
    }
  })
}

const calcQuestionNum = groupList => {
  let num = 1
  groupList.forEach(group => {
    group.questionList.forEach(item => {
      if (item.elementType !== 'PageBox') {
        item.quNum = `Q${num++}`
      }
    })
  })
}

const calcNum = groupList => {
  let num = 0
  let code = 65
  let groupOrderbyId = 0
  groupList.forEach(group => {
    const { groupType, questionList } = group
    if (groupType === '1') {
      group.quNum = 'S'
    } else if (groupType === '2') {
      group.quNum = String.fromCharCode(code++)
    }
    group.orderById = groupOrderbyId
    group.allOrderById = (groupOrderbyId++) * 1000
    if (questionList) {
      const allOrderById = group.allOrderById
      let itemOrderById = 0
      let quId
      questionList.forEach(item => {
        if (item.elementType !== 'PageBox') {
          if (quId && quId === item.id) {
            item.quNum = `Q${num}`
          } else {
            item.quNum = `Q${++num}`
          }
          quId = item.id
          item.orderById = itemOrderById
          item.allOrderById = allOrderById + itemOrderById++
        }
      })
    }
  })
}

const TYPE_MAPP = {
  'RadioBox': 'RADIO',
  'GroupBox': 'PARAGRAPH',
  'PageBox': 'PAGETAG',
  'CheckBox': 'CHECKBOX',
  'TitleBox': 'FILLBLANK',
  'RadioBoxGroup': 'CHENRADIO',
  'CheckBoxGroup': 'CHENCHECKBOX',
  'InfoBox': 'TITLE',
  'NpsBox': 'NPS',
  'RateBox': 'SCORE',
  'RateGroupBox': 'CHENSCORE',
  'NumberBox': 'NUMBER',
  'FillBlankBox': 'MULTIFILLBLANK',
  'SelectBox': 'SELECT',
  'CascadeBox': 'CASCADE',
  'MusicBox': 'MUSIC',
  'TimeBox': 'TIME',
  'UploadFileBox': 'UPLOADFILE',
  'SatisfactionBox': 'SATISFACTION',
  'SortBox': 'ORDERQU',
  'MultiNumberBox': 'MULTI_NUMBER',
  'MultiFillBlankBox': 'MULTI_FILLBLANK',
  // 'TimeBox': 'TIME',
  // 'ChipBox': 'PROPORTION',
  // 'GpsBox': 'GPS',
  // 'CeBox': 'CE',
  // 'IatBox': 'TIMENOTES',
  // 'MediaBox': 'MEDIA',
  // 'ImageBox': 'IMAGE',
  // 'MusicBox': 'MUSIC'
}

const convertQuType = config => {
  return config.baseElementType || TYPE_MAPP[config.elementType]
}

const isSelected = (value, itemValue) => {
  value = str2arr(value)
  return value.includes(itemValue)
}

const str2arr = (str) => {
  let result = []
  if (str) {
    if (!(str instanceof Array)) {
      str = str + ''
      result = str.split(',')
    } else {
      result = str
    }
  }
  return result
}

const isInArr = (arr1, arr2) => {
  const len1 = arr1.length
  const len2 = arr2.length
  return len1 <= len2 && arr1.filter(item => arr2.includes(item)).length === len1
}

const isContainsArr = (arr1, arr2) => {
  return arr1.filter(item => arr2.includes(item)).length
}

const isSameArr = (arr1, arr2) => {
  const len1 = arr1.length
  const len2 = arr2.length
  return len1 === len2 && new Set([...arr1, ...arr2]).size === len1
}

const isNull = (obj) => {
  var type = varType(obj)
  if (type !== 'number' && !obj) {
    return true
  }
  if (type === 'array') {
    return !obj.length
  } else if (type === 'object') {
    return !Object.keys(obj).length
  }
  return false
}

const genStyle = (text) => {
  const style = document.createElement('style')
  style.innerText = text
  document.body.appendChild(style)
}

const genFont = (model, prefix) => {
  let style = ''
  const fontSize = model[prefix + 'FontSize']
  const color = model[prefix + 'Color']
  const boldInd = model[prefix + 'BoldInd']
  const fontItalicInd = model[prefix + 'FontItalicInd']
  const underLineInd = model[prefix + 'UnderLineInd']
  if (fontSize) {
    style += 'font-size: ' + fontSize + 'px' + IPT
    style += 'line-height: ' + (fontSize + fontSize * 0.5) + 'px' + IPT
  }
  if (color) {
    style += 'color: ' + color + IPT
  }
  if (boldInd === '1') {
    style += 'font-weight: bold' + IPT
  }
  if (fontItalicInd === '1') {
    style += 'font-style: italic' + IPT
  }
  if (underLineInd === '1') {
    style += 'text-decoration: underline' + IPT
  }
  return style
}

// 查询并初始化外观设置
const contrlStyle = function (param) {
  const old = this.answerStyleConfig.question
  return this.GET_STYLE(param).then(_ => {
    let styleText = ''
    let { answerStyleConfig } = this
    const { fengmian, fengge, common, button, endPage, font } = answerStyleConfig

    if (common.showQuNumInd === '0') {
      styleText += '.answer .qu-num {display:none;}'
    } else {
      styleText += '.answer .qu-num {display:inline;}'
    }
    if (fengge.color) {
      styleText += '.answer .answer-container .an-body .option.selected { border-color:' + fengge.color + IPT + ';background:' + fengge.color + '80' + IPT + '}'
      styleText += '.right .sort-num { border-color:' + fengge.color + IPT + ';background:' + fengge.color + IPT + '}'
    }
    const filterOssLink = Vue.filter('filterOssLink')
    if (fengmian.imgType === '01') {
      // 设置封面图片
      styleText += '.cover-container { background-image: url(' + "'" + filterOssLink(fengmian.imgUrl) + "'" + ')' + IPT + ';}'
    } else {
      // 设置封面纯色
      styleText += '.cover-container { background: ' + fengmian.color + IPT + ' }'
    }
    if (fengmian.logoPositionType === '01') {
      styleText += '.comp-container .card-box .log-box{ text-align: left '+ IPT + '; }'
    } else if (fengmian.logoPositionType === '02') {
      styleText += '.comp-container .card-box .log-box{ text-align: center '+ IPT + '; }'
    } else if (fengmian.logoPositionType === '03') {
      styleText += '.comp-container .card-box .log-box{ text-align: right '+ IPT + '; }'
    }
    if (fengmian.btnBgColor) {
      styleText += '.comp-container .card-box .action .van-button{ background-color: ' + fengmian.btnBgColor + IPT + '; border-color: ' + fengmian.btnBgColor + IPT + ' }'
    }
    if (fengmian.btnTextColor) {
      styleText += '.comp-container .card-box .action .van-button{ color: ' + fengmian.btnTextColor + IPT + '; }'
      styleText += '.comp-container .slide-box{ color: ' + fengmian.btnTextColor + IPT + '; }'
    }
    if (fengmian.titlePositionType === '01') {
      styleText += '.titleArea{ justify-content: flex-start ' + IPT + ';}'
    } else if (fengmian.titlePositionType === '02') {
      styleText += '.titleArea{ justify-content: center ' + IPT + ';}'
    } else if (fengmian.titlePositionType === '03') {
      styleText += '.titleArea{ justify-content: flex-end ' + IPT + ';}'
    }

    // 封面样式
    let titleFont = genFont(fengmian, 'title')
    styleText += '.titleFontStyle{' + titleFont + '}'
    if (fengmian.titleAlignType === '01') {
      styleText += '.comp-container .card-box .title{  text-align: left ' + IPT + '; } '
    }
    if (fengmian.titleAlignType === '02') {
      styleText += '.comp-container .card-box .title{ text-align: center ' + IPT + '; } '
    }
    if (fengmian.titleAlignType === '03') {
      styleText += '.comp-container .card-box .title{ text-align: right ' + IPT + '; } '
    }
    if (fengmian.titleColor) {
      styleText += '.comp-container .card-box .chat-box .info .name, .comp-container .card-box .chat-box .info .sub-title {color: ' + fengmian.titleColor + IPT + '; } '
    }
    if (font.endColor) {
      styleText += '.end-container .card-box .chat-wrapper .info .name, .end-container .card-box .chat-wrapper .info .sub-title, .end-container .card-box .content .subtitle  {color: ' + font.endColor + IPT + '; } '
    }

    this.questionStyle = answerStyleConfig.question
    if (this.questionStyle.showBgInd === '1') {
      if (this.questionStyle.bgImgUrl || this.questionStyle.bgColor) {
        styleText += '.question-wrapper, .chat-box { background: #FFFFFF' + alpha[100 - this.questionStyle.opacity] + IPT + '; }'
      }
      if (this.questionStyle.bgType === '02') {
        styleText += ' .answer-wrap, .answer-mobile .chat-container { background-color: ' + this.questionStyle.bgColor + IPT + ' } '
      }
      if (this.questionStyle.bgType === '01') {
        styleText += '.answer-wrap, .answer-mobile .chat-container { background-image: url(' + "'" + filterOssLink(this.questionStyle.bgImgUrl) + "'" + ')' + IPT + ';background-size: cover ' + IPT + ';background-repeat: no-repeat ' + IPT + ';background-position: center ' + IPT + ';}'
      }
    }
    let questionFont = genFont(this.questionStyle, 'yemei')
    if (questionFont) {
      styleText += '.question-style{ ' + questionFont + ' } '
    }
    if (this.questionStyle.yemeiBgColor) {
      styleText += '.question-style{  background-color: ' + this.questionStyle.yemeiBgColor + ' } '
    }
    if (this.questionStyle.yemeiAlignType === '01') {
      styleText += '.question-style{  text-align: left; } '
    }
    if (this.questionStyle.yemeiAlignType === '02') {
      styleText += '.question-style{ text-align: center; } '
    }
    if (this.questionStyle.yemeiAlignType === '03') {
      styleText += '.question-style{ text-align: right; } '
    }

    // 结束页样式
    let endFont = genFont(font, 'end')
    if (endFont) {
      styleText += '.tips-wrapper .content-box .msg{' + endFont + '}'
    }

    // const { font, button } = answerStyleConfig
    // TOOD 待考虑更优方案（由于题干、选项等支持富文本，此处样式会产生冲突）
    // 字体设置
    // let quStyle = genFont(font, 'qu')
    // if (quStyle) {
    //   quStyle = '.titleFontStyle{ ' + quStyle + ' } '
    //   styleText += quStyle
    // }
    // let welComeStyle = genFont(font, 'welcome')
    // if (welComeStyle) {
    //   welComeStyle = '.welcome-tip{ ' + welComeStyle + ' } '
    //   styleText += welComeStyle
    // }
    // let descStyle = genFont(font, 'desc')
    // if (descStyle) {
    //   descStyle = '.desc-style{ ' + descStyle + ' } '
    //   styleText += descStyle
    // }
    // let optionStyle = genFont(font, 'option')
    // if (optionStyle) {
    //   optionStyle = '.option-style{ ' + optionStyle + ' } '
    //   styleText += optionStyle
    // }
    // let endStyle = genFont(font, 'end')
    // if (endStyle) {
    //   endStyle = '.end-style{ ' + endStyle + ' } '
    //   styleText += endStyle
    // }

    // 按钮设置
    const {btnColor, btnTextColor} = button
    if (btnColor || btnTextColor) {
      /*********** 普通问卷 ***********/
      styleText += '.question-wrapper  .schedule .ivu-progress-bg, .question-wrapper .action-box .action-btns .van-button, .answer .answer-wrapper .el-progress-bar__inner { background:' + btnColor + IPT + ';background-color: ' + btnColor + IPT  + ';border-color: ' + btnColor + IPT + ' }'
      styleText += '.option.selected::before, .progress-bar-container .bottom .right-item, .answer-pc .upload-container .svg-icon, .el-upload-list .el-upload-list__item a .file-name { color: ' + btnColor  + IPT + ';}'
      styleText += '.question-wrapper .action-box .action-btns .van-button, .question-wrapper .action-box .action-btns .pre-btn-arrow .svg-icon { color: ' + btnTextColor  + IPT + ';}'
      styleText += '.ivu-spin-show-text .ivu-spin-text { color: ' + btnColor  + IPT + ';}'
      styleText += '.satisfaction-wrap .inner-box .option-box .option-item.item-active { background: ' + btnColor  + IPT + '; color: ' + btnTextColor  + IPT + ';}'
      // 语音题 颜色适配
      styleText += '.audio-wrap .audio-box .progress-bar-wrap .el-slider__runway .el-slider__bar{ background-color: '+colorRgba(btnColor, 0.2)+' }'
      styleText += '.audio-wrap .audio-box .progress-bar-wrap .el-slider__runway .el-slider__button-wrapper .el-slider__button:after, .audio-wrap .audio-box .progress-bar-wrap .el-slider__runway .el-slider__button-wrapper .el-slider__button::after{ background-color: '+colorRgba(btnColor, 1)+' }'
      // element 颜色
      styleText += '.el-radio__input.is-checked + .el-radio__label {' +
        '  color: ' + btnColor + IPT +
        '}' +
        '.el-radio__input.is-checked .el-radio__inner {' +
        '  background: ' + btnColor + IPT +
        '  border-color: ' + btnColor + IPT +
        '}' +
        '.el-checkbox__input.is-checked .el-checkbox__inner {' +
        '  background-color: ' + btnColor + IPT +
        '  border-color: ' + btnColor + IPT +
        '}' +
        '.is-checked {' +
        '  .el-checkbox__label {' +
        '    color: ' + btnColor + IPT +
        '  }' +
        '}'
      /*********** 对答式问卷 ***********/
      styleText += '.chat-container .header { background:' + btnColor + IPT + ';color: ' + btnTextColor + IPT  + ' }'
      styleText += '.msg-container.user-card .msg-box { background: ' + btnColor  + IPT + ';color: ' + btnTextColor + IPT  + ' }'
      styleText += '.user-card .arrow { border-color: transparent ' + btnColor  + IPT + ';}'
      styleText += '.radio-box .option.active, .check-box-wrapper .check-box .option.active, .nps-box .option.active, .answer-pc .check-box-wrapper .check-box .option:hover, .answer-pc .radio-box .option:hover { color: ' + btnColor  + IPT + ';border-color: ' + btnColor + IPT  + ';background: ' + btnColor + '15' + IPT  + ' }'
      styleText += '.answer-pc .nps-box .option { color: ' + btnColor  + IPT + ';border-color: ' + btnColor + IPT  + ';background: ' + btnColor + '15' + IPT  + ' }'
      styleText += '.answer-pc .nps-box .option:hover { background: ' + btnColor  + IPT + ';color: ' + btnTextColor + IPT  + ' }'
      styleText += '.check-box-wrapper .action .van-button, .input-box .action .van-button { background-color: ' + btnColor  + IPT + ';border-color: ' + btnColor + IPT  + ' }'
      styleText += '.input-box .action .van-button .svg-icon { color: ' + btnTextColor  + IPT + ';}'
      styleText += '.chat-box .area-box .select-box { border-color: ' + btnColor  + IPT + ';background: ' + btnColor + '15' + IPT  + ' }'
      styleText += '.chat-box .area-box .select-box .tips { color: ' + btnColor  + IPT + ';}'
      styleText += '.van-tabs__line { background-color: ' + btnColor  + IPT + ';}'
      styleText += '.van-cascader__option--selected, .van-cascader__selected-icon { color: ' + btnColor  + IPT + ';}'
      styleText += '.action-btn .van-button { background: ' + btnColor  + IPT + ';border-color: ' + btnColor + IPT  + ' }'
    }

    if (endPage.showBgInd === '1') {
      if (endPage.bgType === '01') {
        // 设置封面图片
        styleText += '.tips-wrapper, .end-container { background-image: url(' + "'" + filterOssLink(endPage.bgImgUrl) + "'" + ')' + IPT + ';background-size: cover ' + IPT + ';background-repeat: no-repeat ' + IPT + ';background-position:center ' + IPT + ';}'
      } else {
        // 设置封面纯色
        styleText += '.tips-wrapper, .end-container { background-color: ' + endPage.bgColor + IPT + ' }'
      }
    }

    if (endPage.logoPositionType === '01') {
      styleText += '.tips-wrapper .logo-box, .end-container .card-box .action{ text-align: left '+ IPT + '; }'
    } else if (endPage.logoPositionType === '02') {
      styleText += '.tips-wrapper .logo-box, .end-container .card-box .action{ text-align: center '+ IPT + '; }'
    } else if (endPage.logoPositionType === '03') {
      styleText += '.tips-wrapper .logo-box, .end-container .card-box .action{ text-align: right '+ IPT + '; }'
    }

    document.querySelector('#answerStyle').innerHTML = styleText
    const newO = this.questionStyle
    if (newO.yemeiType !== old.yemeiType || newO.manyType !== old.manyType || newO.yemeiText !== old.yemeiText || newO.manyInterval !== old.manyInterval || !compareObj.compare(old.yemeiImgAry, newO.yemeiImgAry)) {
      this.isShowHeader = false
      setTimeout(() => {
        this.isShowHeader = true
      }, 0)
    }
  })
}

const bool2str = (bool) => {
  return bool * 1 + ''
}

const param = data => {
  let url = ''
  for (let k in data) {
    let value = data[k] !== undefined ? data[k] : ''
    url += `&${k}=${encodeURIComponent(value)}`
  }
  return url ? url.substring(1) : ''
}

const getSurveyCode = (param, dataList, cb) => {
  getSurveyCodeService(param).then(ret => {
    ret.map(({ code, zhName }) => {
      dataList.push({
        label: zhName,
        value: code
      })
    })
    cb && cb(ret)
  })
}

const getSurveySubCode = (param, dataList, cb) => {
  getSurveySubCodeService(param).then(ret => {
    dataList.splice(0, dataList.length)
    ret.map(({ code, zhName }) => {
      dataList.push({
        label: zhName,
        value: code
      })
    })
    cb && cb(ret)
  })
}

/**
 * JS颜色十六进制转换为rgb或rgba,返回的格式为 rgba（255，255，255，0.5）字符串
 * sHex为传入的十六进制的色值
 * alpha为rgba的透明度
 */
const colorRgba = (sHex, alpha = 1) => {
  // 十六进制颜色值的正则表达式
  var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/
  /* 16进制颜色转为RGB格式 */
  let sColor = sHex.toLowerCase()
  if (sColor && reg.test(sColor)) {
    if (sColor.length === 4) {
      var sColorNew = '#'
      for (let i = 1; i < 4; i += 1) {
        sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
      }
      sColor = sColorNew
    }
    //  处理六位的颜色值
    var sColorChange = []
    for (let i = 1; i < 7; i += 2) {
      sColorChange.push(parseInt('0x' + sColor.slice(i, i + 2)))
    }
    // return sColorChange.join(',')
    // 或
    return 'rgba(' + sColorChange.join(',') + ',' + alpha + ')'
  } else {
    return sColor
  }
}

/**
 * 处理多语言
 * @param {*} id
 * @param {*} title
 * @returns
 */
const cvtLang = (langMap, lang, id, title) => {
  if (lang === 'origin') {
    return title
  }
  const key = `${id}_${lang}`
  const value = langMap[key]
  if (!value) {
    langMap[key] = ''
  }
  return langMap[key]
}

/**
 * 逻辑组验证
 * @param {*} logicGroup 逻辑组
 * @param {*} userInfo 客户信息
 * @param {*} questionList 问题列表
 * @param {*} Logic 各种题型的logic定义
 * @param {*} custQuote 引用集合
 * @param {*} custValidFlag 是否包含客户属性的验证
 * @returns
 */
const ifLogicGroup = function (logicGroup, userInfo, questionList, Logic, custQuote, custValidFlag=false) {
  // 每组逻辑的验证结果列表
  const logicGroupValidList = []
  const custLogicGroupValidList = []

  // 遍历逻辑组列表，验证此组逻辑是否符合
  // for (const subFilter of logicGroup.subFilter) {
  for (let i=0; i<logicGroup.subFilter.length; i++) {
    // 每条逻辑的验证结果列表
    const subFilterValidList = []
    const custSubFilterValidList = []

    // 遍历逻辑组的每个逻辑，并验证逻辑符合。
    // for (const logic of logicGroup.subFilter[i].list) {
    for (let j=0; j<logicGroup.subFilter[i].list.length; j++) {
      let commonValidLogic = false
      let custValidLogic = true

      // 问题逻辑/客户属性逻辑（'question'：问题逻辑；'clientProperty'：客户属性逻辑）
      if ([1, 'question'].includes(logicGroup.subFilter[i].list[j].logicType)) {
        const {anQuId, anQuType, anSubQuId, anQuItemId, anValue} = logicGroup.subFilter[i].list[j]

        // 获取问题及答案
        const {question, quValue} = getQuestionAndValue(questionList, anQuId, anQuType, anSubQuId, anQuItemId)

        if (question && quValue && quValue.toString().length > 0) {
          // 问题答案转为数组
          const quValueList = str2arr(quValue)
          // 逻辑条件选项ID，转为数组
          const anQuItemIdList = str2arr(anQuItemId)
          // 逻辑条件答案，转为数组
          const anValueList = str2arr(anValue)

          // 处理各题型逻辑验证（由于各题型逻辑验证符合返回false，所以需要取反）
          // chooseType（1：选择；2：未选择）
          if (Logic[question.elementType] && Logic[question.elementType].getQuBeforLogicsExpress) {
            commonValidLogic = Logic[question.elementType].getQuBeforLogicsExpress.bind(this)(
              logicGroup.subFilter[i].list[j],
              question,
              quValueList,
              anQuItemIdList,
              anValueList
            )
          }
        }
      } else if ([2, 'clientProperty'].includes(logicGroup.subFilter[i].list[j].logicType)
        || logicGroup.subFilter[i].list[j].logicType === 'event'
        || logicGroup.subFilter[i].list[j].logicType === 'customTag'
        || logicGroup.subFilter[i].list[j].logicType === 'tag'
        || logicGroup.subFilter[i].list[j].logicType === 'carTag') {
        // 验证客户属性符合条件，符合则返回true，否则false
        commonValidLogic = ifpropertyLogic(logicGroup.subFilter[i].list[j], custQuote)
        custValidLogic = commonValidLogic
      }

      // 记录每条逻辑的验证结果
      subFilterValidList.push(commonValidLogic)

      // 记录每条客户属性逻辑的验证结果
      custSubFilterValidList.push(custValidLogic)
    }

    // 记录每组逻辑的验证结果
    logicGroupValidList.push(ifLogicValid(logicGroup.subFilter[i].logicalOperator, subFilterValidList))
    custLogicGroupValidList.push(ifLogicValid(logicGroup.subFilter[i].logicalOperator, custSubFilterValidList))
  }

  // 验证该内容逻辑是否为true，并返回验证结果
  // console.log(999, ifLogicValid(logicGroup.logicalOperator, logicGroupValidList))
  return custValidFlag ? {
    visibility: ifLogicValid(logicGroup.logicalOperator, logicGroupValidList),
    custValidResult: ifLogicValid(logicGroup.logicalOperator, custLogicGroupValidList)
  } : ifLogicValid(logicGroup.logicalOperator, logicGroupValidList)
}

/**
 * 获取问题及答案
 * @param {*} questionList
 * @param {*} anQuId
 * @param {*} anQuType
 * @param {*} anSubQuId
 * @returns
 */
const getQuestionAndValue = function (questionList, anQuId, anQuType, anSubQuId, anQuItemId) {
  // 获取问题
  const question = questionList.find(qu => qu.id === anQuId)

  let quValue = null
  if (question) {
    // 问题答案：默认问题答案
    quValue = question.value

    // 问题答案：如果是问题逻辑是矩阵单选/矩阵多选等，获取子问题的答案
    if (anSubQuId) {
      if (anQuType === 'TIMENOTES' || anQuType === 'CHENSCORE') {
        // 题型：图文上下、矩阵滑块
        quValue = question.descList.find(item => item.id === anSubQuId).value
      } else if (anQuType === 'CHENRADIO' || anQuType === 'CHENCHECKBOX') {
        // 题型：矩阵单选、矩阵多选
        /**
         * Tip：这两种题目，子问题会拆为多个question，且实际答案存储在descList对应的question的索引的对象里
         * eg：矩阵单选有三个子问题，则会拆分为三个question
         * 子问题1：question0，对应的答案在：question0.descList[0]
         * 子问题2：question1，对应的答案在：question1.descList[1]
         * 子问题3：question2，对应的答案在：question2.descList[2]
         */
        let descValue = ''
        questionList.filter(qu => qu.id === anQuId).some(item => {
          const descItem = item.descList.find((desc, index) => index === item.descIndex && desc.id === anSubQuId) || {}
          descValue = descItem.value || ''
          return !!descValue
        })
        quValue = descValue
      }
    } else if (anQuType === 'MULTI_NUMBER' || anQuType === 'MULTI_FILLBLANK') {
      // 多项数字、填空题
      quValue = question.optionList.find(item => item.id === anQuItemId) ? question.optionList.find(item => item.id === anQuItemId).value : ''
    }

  }

  return {question, quValue}
}

/**
 * 验证逻辑组合是否为true
 * "或"，有一组逻辑为true，则返回true
 * "且"，所有逻辑组都不为false，则返回true
 * @param {*} logicalOperator
 * @param {*} logicValidList
 * @returns
 */
const ifLogicValid = function (logicalOperator, logicValidList) {
  if ((logicalOperator === 'or' && logicValidList.indexOf(true) > -1) ||
    (logicalOperator === 'and' && logicValidList.indexOf(false) === -1)) {
    return true
  }
  return false
}

/**
 * 验证客户属性
 * @param {*} logicSet
 * @param {*} custQuote
 * @returns
 */
const ifpropertyLogic = function (logicSet, custQuote) {

  let quoteObj, quoteValue
  if (Array.isArray(custQuote[logicSet.logicType])) {
    quoteObj = custQuote[logicSet.logicType].find(item => item.field === logicSet.attribute + '')
  }

  quoteValue = quoteObj ? (quoteObj.value || '') : ''

  // 如果用户属性为null, 直接返回false
  if (!quoteObj) {
    return false
  }

  // 如果用户属性中无逻辑字段
  if (!quoteValue || ['[]', 'null', ''].includes(quoteValue)) {
    // 无值
    if (logicSet.condition === 'null') { // 如果逻辑条件为空
      return true
    }
    if (logicSet.condition === 'nenull') { // 如果逻辑条件为不空
      return false
    }
  } else {
    // 有值
    if (logicSet.condition === 'null') { // 如果逻辑条件为空
      return false
    }
    if (logicSet.condition === 'nenull') { // 如果逻辑条件为不空
      return true
    }
  }

  // 客户事件
  if (logicSet.logicType === 'event' && logicSet.attributeType === 'String' && quoteValue) {
    const valArr = JSON.parse(quoteValue)
    if (logicSet.condition === 'eq') { // 等于
      if (valArr.length && valArr.indexOf(logicSet.attributeVal) > -1) {
        return true
      }
    }
    if (logicSet.condition === 'ne') { // 不等于
      if (valArr.length && valArr.indexOf(logicSet.attributeVal) === -1) {
        return true
      }
    }
    if (logicSet.condition === 'regex') { // 包含
      if (valArr.length && valArr.some(item => item.indexOf(logicSet.attributeVal) > -1)) {
        return true
      }
    }
    if (logicSet.condition === 'nenull') { // 不为空
      if (!['[]', 'null', ''].includes(quoteValue)) {
        return true
      }
    }
    if (logicSet.condition === 'null') { // 为空
      if (['[]', 'null', ''].includes(quoteValue)) {
        return true
      }
    }
    return false
  }

  // 自定义标签
  if (logicSet.attributeType === 'customTag') {
    if (logicSet.condition === 'eq') { // 等于
      if (quoteValue.indexOf(logicSet.attributeVal + '') > -1) {
        return true
      }
    }
    if (logicSet.condition === 'in') { // 等于其中之一(多值) 包含
      const toStrList = logicSet.attributeVal.join(',').split(',')
      let flg = false
      if (toStrList && toStrList.length) {
        for (let i=0; i<toStrList.length; i++) {
          if (quoteValue.indexOf(toStrList[i]) > -1) {
            flg = true
            break
          }
        }
      }
      return flg
    }
  }

  // 字符
  if (logicSet.attributeType === 'Text' || logicSet.attributeType === 'String') {
    if (logicSet.condition === 'eq') { // 等于
      if (quoteValue === logicSet.attributeVal) {
        return true
      }
    }
    if (logicSet.condition === 'in' || logicSet.condition === 'regex') { // 等于其中之一(多值) 包含
      if (logicSet.condition === 'in' && logicSet.attributeVal.indexOf(quoteValue) > -1) {
        // 等于其中之一
        return true
      }
      if (logicSet.condition === 'regex' && quoteValue.indexOf(logicSet.attributeVal) > -1) {
        // 客户属性包含
        return true
      }
      if (quoteValue && /\[.*?\]/.test(quoteValue)) {
        // value为数组字符串
        const quoteValueArr = JSON.parse(quoteValue).map(val => val + '')
        if (Array.isArray(logicSet.attributeVal)) {
          // 数组比对交集（长度不相等则有交集）
          return (quoteValueArr.length + logicSet.attributeVal.length) !== new Set([...quoteValueArr, ...logicSet.attributeVal]).size
        } else if (!Array.isArray(logicSet.attributeVal) && quoteValueArr.indexOf(logicSet.attributeVal + '') > -1) {
          return true
        }
      }
    }
    if (logicSet.condition === 'ne') { // 不等于
      if (quoteValue !== logicSet.attributeVal) {
        return true
      }
    }

    if (logicSet.condition === 'null') { // 如果逻辑条件为空
      if (quoteValue === '' || quoteValue === null) {
        return true
      }
    }
    if (logicSet.condition === 'nenull') { // 如果逻辑条件为不空
      if (quoteValue !== '' && quoteValue !== null) {
        return true
      }
    }
  }

  // 数值
  if (logicSet.attributeType === 'Number') {
    let formatQuoteValue = quoteValue
    if (Array.isArray(JSON.parse(formatQuoteValue))) {
      formatQuoteValue = JSON.parse(formatQuoteValue)[0]
    }

    if (logicSet.condition === 'eq') { // 等于
      if (Number(formatQuoteValue) === Number(logicSet.attributeVal)) {
        return true
      }
    }
    if (logicSet.condition === 'ne') { // 不等于
      if (Number(formatQuoteValue) !== Number(logicSet.attributeVal)) {
        return true
      }
    }
    if (logicSet.condition === 'gt') { // 大于
      if (Number(formatQuoteValue) > Number(logicSet.attributeVal)) {
        return true
      }
    }
    if (logicSet.condition === 'gte') { // 大于等于
      if (Number(formatQuoteValue) >= Number(logicSet.attributeVal)) {
        return true
      }
    }
    if (logicSet.condition === 'lt') { // 小于
      if (Number(formatQuoteValue) < Number(logicSet.attributeVal)) {
        return true
      }
    }
    if (logicSet.condition === 'lte') { // 小于等于
      if (Number(formatQuoteValue) <= Number(logicSet.attributeVal)) {
        return true
      }
    }
    if (logicSet.condition === 'between') { // 区间
      if (
        Array.isArray(logicSet.attributeVal) &&
        (logicSet.attributeVal[0] && logicSet.attributeVal[1]) &&
        (
          Number(formatQuoteValue) >= Number(logicSet.attributeVal[0]) &&
          Number(formatQuoteValue) <= Number(logicSet.attributeVal[1])
        )
      ) {
        return true
      }
    }
  }

  // 日期
  if (logicSet.attributeType === 'Date' && quoteValue && logicSet.attributeVal) {
    let formatQuoteValue = quoteValue
    if (Array.isArray(JSON.parse(quoteValue))) {
      formatQuoteValue = JSON.parse(quoteValue)[0]
    }

    const dateVal = new Date(formatQuoteValue.replace(/-/g, '/')).getTime()
    let time
    if (typeof logicSet.attributeVal === 'string') {
      time = new Date(logicSet.attributeVal.replace(/-/g, '/')).getTime()
    }
    if (logicSet.condition === 'eq') { // 等于
      if (dateVal === time) {
        return true
      }
    }
    if (logicSet.condition === 'ne') { // 不等于
      if (dateVal !== time) {
        return true
      }
    }
    if (logicSet.condition === 'gt') { // 晚于
      if (dateVal > time) {
        return true
      }
    }
    if (logicSet.condition === 'gte') { // 晚于(含)
      if (dateVal >= time) {
        return true
      }
    }
    if (logicSet.condition === 'lt') { // 早于
      if (dateVal < time) {
        return true
      }
    }
    if (logicSet.condition === 'lte') { // 早于(含)
      if (dateVal <= time) {
        return true
      }
    }
    if (logicSet.condition === 'between') { // 区间
      if (
        Array.isArray(logicSet.attributeVal) &&
        (logicSet.attributeVal[0] && logicSet.attributeVal[1])
      ) {
        const between1 = new Date(dateAddTime(logicSet.attributeVal[0], 1).replace(/-/g, '/')).getTime()
        const between2 = new Date(dateAddTime(logicSet.attributeVal[1], 2).replace(/-/g, '/')).getTime()
        if (dateVal > between1 && dateVal < between2) {
          return true
        }
      }
    }
  }

  // 日期时间
  if (logicSet.attributeType === 'DateTime' && logicSet.attributeVal) {
    let formatQuoteValue = quoteValue
    if (Array.isArray(JSON.parse(quoteValue))) {
      formatQuoteValue = JSON.parse(quoteValue)[0]
    }

    const dateVal = new Date(formatQuoteValue.replace(/-/g, '/')).getTime()
    const time = new Date(logicSet.attributeVal.replace(/-/g, '/')).getTime()
    if (logicSet.condition === 'eq') { // 等于
      if (dateVal === time) {
        return true
      }
    }
    if (logicSet.condition === 'ne') { // 不等于
      if (dateVal !== time) {
        return true
      }
    }
    if (logicSet.condition === 'gt') { // 晚于
      if (dateVal > time) {
        return true
      }
    }
    if (logicSet.condition === 'gte') { // 晚于(含)
      if (dateVal >= time) {
        return true
      }
    }
    if (logicSet.condition === 'lt') { // 早于
      if (dateVal < time) {
        return true
      }
    }
    if (logicSet.condition === 'lte') { // 早于(含)
      if (dateVal <= time) {
        return true
      }
    }
    if (logicSet.condition === 'between') { // 区间
      if (
        Array.isArray(logicSet.attributeVal) &&
        (logicSet.attributeVal[0] && logicSet.attributeVal[1])
      ) {
        const between1 = new Date(logicSet.attributeVal[0].replace(/-/g, '/')).getTime()
        const between2 = new Date(logicSet.attributeVal[1].replace(/-/g, '/')).getTime()
        if (dateVal > between1 && dateVal < between2) {
          return true
        }
      }
    }
  }

  // 布尔
  if (logicSet.attributeType === 'Boolean') {
    let formatQuoteValue = quoteValue
    if (Array.isArray(JSON.parse(quoteValue))) {
      formatQuoteValue = JSON.parse(quoteValue)[0]
    }
    if (logicSet.condition === 'eq') { // 等于
      if (formatQuoteValue === 'true') {
        return true
      }
    }
    if (logicSet.condition === 'ne') { // 不等于
      if (formatQuoteValue !== 'true') {
        return true
      }
    }
  }

  return false
}

const dateAddTime = function (date, t) {
  if (date.length > 10) {
    return date
  } else {
    if (t === 1) {
      return `${date} 00:00:00`
    }
    if (t === 2) {
      return `${date} 23:59:59`
    }
  }
}

const isWechat = function isWechat() {
  return /MicroMessenger/i.test(window.navigator.userAgent);
}

const obj2Param = function(json) {
  if (!json) return ''
  return Object.keys(json).map(key => {
    if (json[key] === undefined) return ''
    return encodeURIComponent(key) + '=' +
            encodeURIComponent(json[key])
  }).join('&')
}

const guid =  function() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 | 0
    let v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

const getQueryString = function(key) {
  const searchString = document.location.search.toString()
  let returnValue = ''
  if (searchString.substr(0, 1) === '?' && searchString.length > 1) {
    const queryString = searchString.substring(1, searchString.length)
    const queryList = queryString.split('&')
    for (let i = 0; i < queryList.length; i++) {
      const oneQuery = queryList[i].split('=')
      if (oneQuery[0] === key && oneQuery.length === 2) {
        returnValue = oneQuery[1]
      }
    }
  }
  return returnValue
}

const formatNumber = function(value, decimal) {
  if (!value) {
    return ''
  }
  const s = value.toString().split('.')
  const getZero = function(num) {
    let zero = ''
    for (let i=0; i<num; i++) {
      zero += '0'
    }
    return zero
  }

  if(s.length == 1){
    if (decimal) {
      value = value + '.' + getZero(decimal)
    }
    return value
  }
  if (s.length > 1) {
    value = s[0] + '.' + (s[1].length > decimal ? s[1].substr(0, decimal) : (s[1] + getZero(decimal - s[1].length)))
    return value
  }
}

const util = {
  genList,
  randomSort,
  rotateSort,
  genRetList,
  quoteReplace,
  calcQuNum,
  TYPE_MAPP,
  str2arr,
  isContainsArr,
  isSameArr,
  isInArr,
  isNull,
  contrlStyle,
  genStyle,
  bool2str,
  isSelected,
  calcQuestionNum,
  calcGroupNum,
  calcNum,
  param,
  cloneDeep,
  getSurveyCode,
  getSurveySubCode,
  colorRgba,
  convertQuType,
  cvtLang,
  ifLogicGroup,
  ifpropertyLogic,
  handlePlace,
  isWechat,
  obj2Param,
  guid,
  getQueryString,
  formatNumber
}

export default util



// WEBPACK FOOTER //
// ./src/tools/commonUtil.js